import React from 'react'
import { Link } from 'react-router-dom'
import { removeDuplicateClasses } from './PrimaryButton'

const SecondaryButton = ({
  children,
  to,
  onClick,
  disabled = false,
  className,
  ...props
}) => {
  const baseClasses =
    'h-[50px] text-center font-bold py-2 px-4 rounded focus:bg-secondary-700 flex justify-center items-center'
  const activeClass = 'bg-secondary-950 hover:bg-secondary-600 text-white'
  const disableClass = 'bg-secondary-100 text-secondary-400'
  const combinedClasses = removeDuplicateClasses(
    `${disabled ? disableClass : activeClass} ${baseClasses}`,
    className
  )

  if (to) {
    return (
      <Link to={to} className={combinedClasses} {...props}>
        {children}
      </Link>
    )
  }

  return (
    <button
      onClick={onClick}
      className={combinedClasses}
      disabled={disabled}
      {...props}
    >
      {children}
    </button>
  )
}

export default SecondaryButton
